// /*
// These functions paginate ADA user all reports dashboard
// */

jQuery(document).ready(function () {
    
    let cardsPerPage = 10; // Number of cards to show per page
    let dataContainer = document.getElementById("data-container");
    let pagination = document.getElementById("pagination");
    let prevButton = document.getElementById("prev");
    let nextButton = document.getElementById("next");
    let pageNumbers = document.getElementById("page-numbers");
    let pageNumbersSection = document.getElementById("page-numbers-section");

    if (typeof pagination !== "undefined" && pagination !== null) {
        let cards = Array.from(dataContainer.getElementsByClassName("report"));

        // Calculate the total number of pages
        let currentPage = 1;
        let totalPages = Math.ceil(cards.length / cardsPerPage);

        if (totalPages < 2) {
            pagination.style.display = "none";
            pageNumbersSection.style.display = "none";
        } else {
            let pageLinkHtml = "";

            for (let index = 1; index < totalPages + 1; index++) {
                pageLinkHtml += `<a href='#' class='page-link' data-page='${index}'>${index}</a>`;
            }

            document.getElementById("prev").insertAdjacentHTML("afterend", pageLinkHtml);

            let pageLinks = document.querySelectorAll(".page-link");

            // Function to display cards for a specific page
            function displayPage(page) {
                let startIndex = (page - 1) * cardsPerPage;
                let endIndex = startIndex + cardsPerPage;
                cards.forEach((card, index) => {
                    if (index >= startIndex && index < endIndex) {
                        card.style.display = "flex";
                    } else {
                        card.style.display = "none";
                    }
                });
            }

            // Function to update pagination buttons and page numbers
            function updatePagination() {
                pageNumbers.textContent = `Page ${currentPage} of ${totalPages}`;
                prevButton.disabled = currentPage === 1;
                nextButton.disabled = currentPage === totalPages;
                pageLinks.forEach((link) => {
                    let page = parseInt(link.getAttribute("data-page"));
                    link.classList.toggle("active", page === currentPage);
                });
            }

            // Event listener for "Previous" button
            prevButton.addEventListener("click", () => {
                if (currentPage > 1) {
                    currentPage--;
                    displayPage(currentPage);
                    updatePagination();
                }
            });

            // Event listener for "Next" button
            nextButton.addEventListener("click", () => {
                if (currentPage < totalPages) {
                    currentPage++;
                    displayPage(currentPage);
                    updatePagination();
                }
            });

            // Event listener for page number buttons
            pageLinks.forEach((link) => {
                link.addEventListener("click", (e) => {
                    e.preventDefault();
                    let page = parseInt(link.getAttribute("data-page"));
                    if (page !== currentPage) {
                        currentPage = page;
                        displayPage(currentPage);
                        updatePagination();
                    }
                });
            });

            // Initial page load
            displayPage(currentPage);
            updatePagination();
        }
    }
});
